// extracted by mini-css-extract-plugin
export default {"videoResponsive":"Video_videoResponsive__wSzSD"};